import React from "react";
import "./App.css";
import AppRouter from "./routes/appRouter";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import "./styles/investor.css";
import "./styles/public.css";
import "./i18n";

function App() {
  return (
    <ErrorBoundary>
      <CurrencyProvider>
        <AppRouter />
      </CurrencyProvider>
    </ErrorBoundary>
  );
}

export default App;
